export default __webpack_public_path__ + "static/fox-ffd6d8fb49a6f3bfcb0b886572e15d93.png";